var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":true,"title":"","before-close":_vm.handleClose,"width":"940px"}},[_c('div',{staticClass:"notShow"},[_c('img',{attrs:{"src":_vm.tipList[_vm.type-1],"alt":"示例图"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }